import { Component } from '@angular/core';

@Component({
  selector: 'app-courtier',
  templateUrl: './courtier.component.html',
  styleUrls: ['./courtier.component.scss']
})
export class CourtierComponent {

}
